import { ENVIRONMENT_LINK_ENDPOINTS_NAMES } from '@constants/common/environmentLinkEndpointNames';
import { HEADER_LINKS_TYPES, EXTRA_ACTIONS } from '../constants/headerLinkTypes';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';
import { ssapModalTypes as MODAL_TYPES } from '@constants/ssap/modals/ssapModalTypes';
import { configs } from '@constants/configs/configs';
import { onLogout } from '@utils/localStorage/sessionStorageUtils';
import { IEX_STATE_CODES } from '@constants/configs/states';

const {
    routes
} = configs;

export const nevadaHeaderLogo = {
    link: true
};

export const nevada = {
    linkDetails: [
        {
            name: 'language',
            className: ['usa-nav__primary-item gi-main__nav__primary-item link__language'],
            linkClassName:['gi-main__nav__primary-item__link'],
            text: 'header.lang',
            path: '#',
            type: HEADER_LINKS_TYPES.LANGUAGE_SWITCH,
            visible: environment => environment.anonymous || environment.impersonation || environment.user && environment.user.role === ALL_USER_ROLES.INDIVIDUAL
        },
        {
            name: 'login',
            text: 'header.login',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.LOGIN,
            type: HEADER_LINKS_TYPES.LINK,
            visible: environment => environment.anonymous
        },
        {
            name: 'home',
            text: 'header.home',
            textClassname: ['usa-sr-only'],
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link'],
            symbols: ['home'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.DASHBOARD,
            type: HEADER_LINKS_TYPES.ICON,
            visible: (environment, currentPath, telexEnabled, errorStatus) => !environment.anonymous && !errorStatus,
            urlReplacements: [ENVIRONMENT_LINK_ENDPOINTS_NAMES.PHONE]
        },
        {
            name: 'secured-mail',
            text: 'header.inbox',
            textClassname: ['usa-sr-only'],
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link secured-mail'],
            symbols: ['envelope'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.UNREAD_MESSAGES,
            type: HEADER_LINKS_TYPES.ICON,
            visible: (environment, currentPath, telexEnabled, errorStatus) => !telexEnabled && !environment.anonymous && !errorStatus,
            showUnreadMessage: true
        },
        {
            name: 'secured-mail-telex',
            text: 'header.inbox',
            textClassname: ['usa-sr-only'],
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link secured-mail'],
            symbols: ['envelope'],
            path: routes.NEW_INBOX_HOME,
            type: HEADER_LINKS_TYPES.ICON_REACT_ROUTER,
            visible: (environment, currentPath, telexEnabled, errorStatus) => telexEnabled && !environment.anonymous && !errorStatus,
            showUnreadMessage: true
        },
        {
            name: 'get-assistance',
            text: 'header.getAssistance',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            btnClassName: ['dropdown__pos--01'],
            ariaClassName: ['extended-nav-section-one'],
            path: '#',
            type: HEADER_LINKS_TYPES.DROPDOWN,
            statesHasFeature: environment => environment.stateCode === IEX_STATE_CODES.NV,
            visible : environment => (environment.user && [
                ALL_USER_ROLES.INDIVIDUAL,
                ALL_USER_ROLES.BROKER,
                ALL_USER_ROLES.ISSUER_REPRESENTATIVE,
                ALL_USER_ROLES.ASSISTER].some(
                role => role === environment.user.role )
                || environment.impersonation || environment.anonymous),

            dropdown: [
                {
                    name: 'Chat',
                    text: 'header.getAssistance.chat',
                    className: ['usa-nav__submenu-item'],
                    path: language => language === 'es' ? ENVIRONMENT_LINK_ENDPOINTS_NAMES.CHAT_NOT_LOGIN_ES : ENVIRONMENT_LINK_ENDPOINTS_NAMES.CHAT_NOT_LOGIN_EN, 
                    type: HEADER_LINKS_TYPES.CHAT,
                    additionalProperties: {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    },
                    visible: environment => !environment.user
                },
                {
                    name: 'Chat',
                    text: 'header.getAssistance.chat',
                    className: ['usa-nav__submenu-item'],
                    path: language => language === 'es' ? ENVIRONMENT_LINK_ENDPOINTS_NAMES.CHAT_LOGIN_ES : ENVIRONMENT_LINK_ENDPOINTS_NAMES.CHAT_LOGIN_EN, 
                    type: HEADER_LINKS_TYPES.CHAT,
                    visible: environment => environment.user
                },
                {
                    name: 'find-assistance',
                    className: ['usa-nav__submenu-item'],
                    text: 'header.getAssistance.localAssistance',
                    path: '#',
                    type: HEADER_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
                    visible: environment => ((environment.user && ALL_USER_ROLES.INDIVIDUAL === environment.user.role) || environment.impersonation || environment.anonymous)
                },
                {
                    name: 'faq',
                    text: 'header.getAssistance.faq',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:[''],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.HELP,
                    type: HEADER_LINKS_TYPES.LINK,
                    additionalProperties: {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    }
                },
                {
                    name: 'contact',
                    text: 'header.getAssistance.contactUs',
                    className: ['usa-nav__submenu-item'],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.CONTACT_US,
                    type: HEADER_LINKS_TYPES.LINK,
                    additionalProperties: {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    }
                }
            ]
        },
        {
            name: 'my-account',
            text: 'header.myAccount',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            btnClassName: ['dropdown__pos--02'],
            ariaClassName: ['extended-nav-section-two'],
            path: '#',
            type: HEADER_LINKS_TYPES.DROPDOWN,
            statesHasFeature: environment => environment.stateCode === IEX_STATE_CODES.NV,
            visible: (environment, currentPath, telexEnabled, errorStatus) => (!environment.anonymous && !errorStatus),
            dropdown: [
                
                {
                    name: 'account-settings',
                    text: 'header.myAccount.accountSettings',
                    className: ['usa-nav__submenu-item'],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.SETTINGS,
                    type: HEADER_LINKS_TYPES.LINK

                },
                {
                    name: 'dashboard',
                    text: 'header.myAccount.dashboard',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:[''],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.DASHBOARD,
                    type: HEADER_LINKS_TYPES.LINK
                },
                {
                    name: 'logout',
                    text: 'header.myAccount.logout',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:[],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.LOGOUT,
                    type: HEADER_LINKS_TYPES.LINK,
                    extraAction: EXTRA_ACTIONS.CHECK_SSAP,
                    beforeClick: onLogout
                }
            ]
        }
    ]
};